import React from "react";

const CheckboxType = (props) => {
  let className = "form-group pt-6 pl-3";
  if (props.showInDocUpload) {
    className = "form-group pt-3";
  }
  if (props.viewOnly) {
    className += " view-only row";
  }

  const addCommas = (optionValue) => {
    if (
      props.viewOnly &&
      props.field.fieldValue &&
      props.field.fieldValue.indexOf(optionValue) !==
        props.field.fieldValue.length - 1
    ) {
      return true;
    }
    return false;
  };
  return (
    <div className={className}>
      <label
        className={[
          props.viewOnly ? "col-md-4 col-sm-6" : "bold",
          props.field.fieldLabel.length > 12 && props.viewOnly
            ? "hide-text"
            : "",
        ].join(" ")}
      >
        {props.field.fieldLabel}
        {props.field.fieldRequired && !props.viewOnly && "*"}
      </label>
      {props.viewOnly && (
        <div className="col-md-8 col-sm-6 p-0">
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {props?.field?.fieldValue?.map((option, index) => (
              <div>
                {option}
                {props?.field?.fieldValue?.length - 1 !== index ? "," : null}
              </div>
            ))}
          </div>
        </div>
      )}

      {!props.viewOnly &&
        props.field.options.map((option) => {
          return (
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                maxLength="20"
                id={option.optionId}
                name={props.field.fieldId}
                value={option.optionValue}
                onChange={props.checkboxValueChangeHandler}
                disabled={props.viewOnly}
                checked={
                  props.field.fieldValue &&
                  props.field.fieldValue.includes(option.optionValue)
                }
              />
              <label
                className={[
                  "form-check-label",
                  props.viewOnly ? "col-md-8 col-sm-6" : "",
                ].join(" ")}
                htmlFor={option.optionId}
              >
                {option.optionValue}{" "}
                {addCommas(option.optionValue) ? "," : null}
              </label>
            </div>
          );
        })}
    </div>
  );
};

export default CheckboxType;
